<div class="not-found-container">
    <p>PAGE NOT FOUND</p>
    <div class="button-container">
        <a class="button-primary" title="Home" routerLink="">Go Back Home</a>
    </div>
</div>